import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadCreatePreparationRequest } from '../../actions/loadCreatePreparation';
import { getCreatePreparation } from '../../selectors';
import { getLoadCreatePreparationError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadCreatePreparationHandler(nextState, successCallback, errorCallback) {
    if (getCreatePreparation(getState())) {
      successCallback();
      return;
    }

    dispatch(
      actionLoadCreatePreparationRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadCreatePreparationError(getState());
        if (error) {
          if (maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)) {
            return;
          }

          console.consoleError(
            `loadCreatePreparationHandler. Unable to load site. Make redirect to ${INTERNAL_ERROR_URI}`
          );
          errorCallback(INTERNAL_ERROR_URI);
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadCreatePreparationHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
